module.exports = __webpack_public_path__ + "img/full5-min.c18782a3.png";